<template>
  <!-- login box -->
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/1 md:w-1/2 lg:w-1/3 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <!-- title -->
                <div class="mb-4">
                  <img class="ml-auto mr-auto" src="@/assets/images/logo/logo.png" />
                  <p class="text-center">Sign in to start your session.</p>
                </div>

                <div>
                  <!-- username -->
                  <vs-input v-validate="'required|min:3'" name="Username" icon-no-border icon="icon icon-user" icon-pack="feather" label="Username" v-model="username" class="w-full" />
                  <span class="text-danger text-sm">{{ errors.first('Username') }}</span>

                  <!-- password -->
                  <div class="w-full mt-6">
                    <label class="vs-input--label">Password</label>
                    <vx-input-group class="w-full">
                      <vs-input
                        v-validate="'required'"
                        :type="!showPassword && 'password'"
                        name="Password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="password"
                        class="w-full"
                      />

                      <!-- show password toggle -->
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button icon-pack="feather" :icon="showPassword ? 'icon icon-eye' : 'icon icon-eye-off'" @click="showPassword = !showPassword" />
                        </div>
                      </template>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
                  </div>

                  <div class="flex flex-wrap justify-between mt-5">
                    <!-- remember me - checkbox -->
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">&nbsp;Remember Me</vs-checkbox>

                    <!-- login button -->
                    <vs-button :disabled="!validateForm" @click="loginJWT">Sign In</vs-button>
                  </div>

                  <!-- terms - condition - checkbox -->
                  <div class="flex flex-wrap justify-start">
                    <vs-checkbox v-model="terms_and_condition" class="mb-3" /> <router-link to="/term-and-conditions" target="_blank">Terms & Conditions</router-link>
                  </div>

                  <!-- other actions -->
                  <div class="flex flex-wrap flex-col justify-between mb-3 mt-3">
                    <div class="">
                      <!-- <router-link to="/create-an-account">Create An Account</router-link>
                      <br /> -->
                      <!-- <router-link to="/create-a-marketplace-account">Create A Marketplace Account</router-link> -->
                    </div>
                    <router-link to="/forget-password">Forgot Password?</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      username: '',
      password: '',
      checkbox_remember_me: false,
      terms_and_condition: false,
      showPassword: false
    }
  },

  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async loginJWT() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Enter Username and Password',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      if (!this.terms_and_condition) {
        this.$vs.notify({
          title: 'Error',
          text: 'Terms and Condition required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          username: this.username,
          password: this.password
        }
      }

      this.$store
        .dispatch('auth/loginJWT', payload)
        .then(() => {
          this.$router.push('/dashboard')
        })
        .catch((error) => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            time: 10000
          })
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  }
}
</script>
